<template :key="categorySlug || 'default'">
    <div v-if="entries" class="container-fluid preview-blocks content-blocks">
        <div id="journalPreview-masonry" v-if="entries.length" class="preview-blocks-row row masonry-container"
            v-masonry="journalPreview" :transition-duration="animatedMasonryTransition ? '0.3s' : 0"
            item-selector=".item" percent-position="true">
            <div v-masonry-tile class="preview-block-col col-md-6 col-lg-4 item"
                v-for="(entry, index) in entries.slice(0, limit ? limit : entries.length)" :key="index">
                <previewBlockDefaultEntry :entry="entry"
                    @click="openJournalArticle($event, getEntryThemeClass(entry), entry)">
                </previewBlockDefaultEntry>
            </div>
        </div>

        <div v-else class="row content-block-row">
            <div class="col col-centered">
                <text-standard :block="{ text: '<p>' + $tc('noEntriesFound') + '</p>' }"></text-standard>
            </div>
        </div>
        <div v-if="showLeaveTransitionOverlay" class="leave-transition-overlay leave-transition-overlay-white"
            :style="leaveTransitionOverlayWhiteStyle"></div>
        <div v-if="showLeaveTransitionOverlay" class="leave-transition-overlay"
            :class="{ cover: animateLeaveTransitionOverlay }" :style="leaveTransitionOverlayStyle"></div>
        <div ref="heroMeasure" class="journal-preview-heading-measure" aria-hidden="true" tabindex="-1">
            <div ref="heroMeasureSurface" class="entry-header-surface">
                <div class="text-heading-md animation-heading journal-entry-header__heading">
                    <h1 class="entry-title" v-html="measureTitle"></h1>
                    <div class="block entry-credits block-text-standard container-fluid">
                        <div class="row content-block-row">
                            <div class="col">
                                <div v-if="measureCredits" class="credits" v-html="measureCredits"></div>
                                <div v-if="measurePostDate" class="entry-date" v-html="measurePostDate"></div>
                                <div v-if="!measureCredits && !measurePostDate" class="entry-date"
                                    style="opacity: 0; pointer-events: none; min-height: 1em;">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Spinner v-else />
</template>

<script>
import Spinner from '@/components/Spinner';
import textStandard from '@/components/contentBlocks/TextStandard';
import previewBlockDefaultEntry from '@/components/previewBlocks/DefaultEntry';

export default {
    name: 'JournalPreviewBlocks',
    components: {
        Spinner,
        textStandard,
        previewBlockDefaultEntry,
    },
    props: {
        entries: null,
        /*scrollContainer: {
            default: document,
        },*/
        limit: {
            default: 0,
        },
        animatedMasonryTransition: {
            default: true
        }
        // displayStamp: {
        //     default: false,
        // },
        // stampEntries: null,
    },
    computed: {},
    data() {
        return {
            minWidthCol3Layout: 1280,
            minWidthCol2Layout: 768,
            showLeaveTransitionOverlay: false,
            animateLeaveTransitionOverlay: false,
            leaveTransitionOverlayStyle: {},
            leaveTransitionOverlayWhiteStyle: {},
            measureTitle: '',
            measurePostDate: '',
            measureCredits: '',
        };
    },
    watch: {},
    mounted() {
        this.resetLeaveTransitionOverlay();
    },
    unmounted() {
        this.resetLeaveTransitionOverlay();
    },
    activated() {
        this.resetLeaveTransitionOverlay();
        window.dispatchEvent(new Event('resize'));
    },
    deactivated() {
    },
    methods: {
        async openJournalArticle(e, theme, entry) {
            if (this.showLeaveTransitionOverlay) {
                return;
            }
            // Clean up any previous animation styles
            this.resetLeaveTransitionOverlay();
            const heroMetrics = await this.calculateHeroMetrics(entry);
            this.$store.commit('view/setTransitionDuration', 900);
            const currentTarget = e.currentTarget;
            const boundingClientRect = currentTarget.getBoundingClientRect();

            // Calculate initial dimensions from preview card
            const initialHeight = boundingClientRect.bottom - boundingClientRect.top;
            const initialWidth = boundingClientRect.right - boundingClientRect.left;
            // Get header height to ensure animation starts below header
            const headerElement = document.getElementById('site-header');
            const headerHeight = headerElement ? headerElement.clientHeight : 0;
            // Ensure initial top is never above header
            const initialTop = Math.max(boundingClientRect.top, headerHeight);
            // Set initial border radius based on screen size
            const initialBorderRadius = window.innerWidth < 576 ? '8px' : '24px';
            this.leaveTransitionOverlayStyle = {
                backgroundColor: window.getComputedStyle(currentTarget).backgroundColor,
                borderRadius: initialBorderRadius,
                left: boundingClientRect.left + 'px',
                top: initialTop + 'px',
                height: initialHeight + 'px',
                width: initialWidth + 'px',
            };
            this.leaveTransitionOverlayWhiteStyle = {
                backgroundColor: '#ffffff',
                left: '0px',
                right: '0px',
                top: '0px',
                bottom: '0px',
                opacity: '0',
            };
            this.showLeaveTransitionOverlay = true;
            var that = this;
            setTimeout(function () {
                that.animateLeaveTransitionOverlay = true;
                const headerElement = document.getElementById('site-header');
                const headerHeight = headerElement ? headerElement.clientHeight : 0;
                const horizontalGap = heroMetrics ? heroMetrics.horizontalGap : 12;
                // Header now binds directly to nav, so no topGap needed
                const topOffset = headerHeight;
                const heroHeight = heroMetrics ? heroMetrics.height : window.innerHeight - (topOffset + 24);
                // Set border radius based on screen size (sm breakpoint is 576px)
                // Animate from initial 8px to detail page border radius
                if (window.innerWidth < 576) {
                    // On mobile, animate from 8px to 12px (detail page border radius)
                    that.leaveTransitionOverlayStyle.borderRadius = '12px';
                } else {
                    // On desktop, animate from 8px to 24px (detail page border radius)
                    that.leaveTransitionOverlayStyle.borderRadius = '24px';
                }
                // Use clientWidth to account for scrollbar
                const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
                that.leaveTransitionOverlayStyle.left = horizontalGap + 'px';
                that.leaveTransitionOverlayStyle.right = horizontalGap + 'px';
                that.leaveTransitionOverlayStyle.top = topOffset + 'px';
                // Animate height directly, not bottom, to prevent growing then shrinking
                that.leaveTransitionOverlayStyle.height = heroHeight + 'px';
                // Set explicit width to viewport minus margins
                const maxViewportWidth = viewportWidth - (horizontalGap * 2);
                if (window.innerWidth < 576) {
                    // On mobile, also respect initial width (don't grow wider than preview card)
                    const maxWidth = Math.min(initialWidth, maxViewportWidth);
                    that.leaveTransitionOverlayStyle.width = maxWidth + 'px';
                } else {
                    // On desktop/tablet, use viewport width minus margins
                    that.leaveTransitionOverlayStyle.width = maxViewportWidth + 'px';
                }
                // Remove bottom if it was set
                delete that.leaveTransitionOverlayStyle.bottom;
                that.leaveTransitionOverlayWhiteStyle.opacity = '1';
            }, 20);
            setTimeout(function () {
                if (!that.$store.getters['view/get'].pageClass.includes(theme)) {
                    // ios workaround timing problem pageClass: do not set transparent class if theme color already is set
                    that.$store.commit('view/setPageClass', theme + ' transparent-header');
                }
            }, 900);
        },
        async calculateHeroMetrics(entry) {
            if (!this.$refs.heroMeasure || !this.$refs.heroMeasureSurface) {
                return null;
            }
            // Set new values
            this.measureTitle = entry && entry.title ? entry.title : '';
            this.measurePostDate = entry && entry.postDate ? entry.postDate : '';
            this.measureCredits = entry && entry.credits ? entry.credits : '';
            await this.$nextTick();
            // Force a reflow to ensure all styles are applied
            this.$refs.heroMeasure.offsetHeight;
            // Measure just the surface height (the colored background area)
            const surfaceRect = this.$refs.heroMeasureSurface.getBoundingClientRect();
            const measureStyles = window.getComputedStyle(this.$refs.heroMeasure);
            const topGapValue = parseFloat(measureStyles.getPropertyValue('--journal-hero-top-offset')) || 0;
            const horizontalGapValue =
                parseFloat(measureStyles.getPropertyValue('--journal-hero-horizontal-gap')) || 0;
            return {
                height: surfaceRect.height,
                topGap: topGapValue,
                horizontalGap: horizontalGapValue,
            };
        },
        resetLeaveTransitionOverlay() {
            this.showLeaveTransitionOverlay = false;
            this.animateLeaveTransitionOverlay = false;
            this.leaveTransitionOverlayStyle = {};
            this.leaveTransitionOverlayWhiteStyle = {};
            // Clear measurement element content after animation
            this.measureTitle = '';
            this.measurePostDate = '';
            this.measureCredits = '';
        },
        getEntryThemeClass(entry) {
            let themeClass = 'theme-default';
            if (entry && entry.theme) {
                themeClass = 'theme-custom-colors';
            }
            return themeClass;
        },
    },
};
</script>

<style scoped>
.leave-transition-overlay {
    position: fixed;
    transition: all 880ms ease;
    z-index: 1500;
}

.leave-transition-overlay-white {
    z-index: 1049;
    border-radius: 0;
    transition: opacity 880ms ease;
}

.transition-background-color {
    transition: background-color 880ms ease;
    background-color: white;
}
</style>
